// extracted by mini-css-extract-plugin
export default {"container":"zp-z","heading":"Ap-z","text":"Bp-z","info":"Cp-z","link":"Dp-z","fullMaxWidth":"Ep-z"};